import { getConfig, Paths } from '@metorial/frontend-config';
import { SetupLayout } from '@metorial/layout';
import { lastInstanceIdStore, useBoot } from '@metorial/state';
import { Button } from '@metorial/ui';
import { useLayoutEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import bg from '../../../assets/bg.webp';

let joinPaths = (...paths: (string | number | undefined)[]) =>
  paths.filter(Boolean).join('/').replace(/\/+/g, '/');

export let RootRedirect = () => {
  let boot = useBoot();
  let navigate = useNavigate();
  let [params] = useSearchParams();
  let organizationId = params.get('organization_id');
  let path = params.get('path');
  let intent = params.get('intent');

  let [noAccess, setNoAccess] = useState(false);

  let navigatedRef = useRef(false);
  useLayoutEffect(() => {
    if (!boot.data) return;

    lastInstanceIdStore
      .get()
      .then(async lastInstanceId => {
        if (navigatedRef.current || !boot.data) return;

        if (organizationId) {
          let org = boot.data.organizations.find(
            o => o.id === organizationId || o.slug === organizationId
          );
          let orgInstances = boot.data.instances.filter(i => i.organizationId === org?.id);

          let instance = orgInstances.find(i => i.id === lastInstanceId);
          if (!instance) instance = orgInstances[0];

          if (instance && org) {
            return {
              instance,
              organization: org,
              project: instance.project
            };
          }
        }

        let instance = boot.data.instances.find(i => i.id === lastInstanceId);

        if (instance) {
          return {
            instance,
            organization: instance.organization,
            project: instance.project
          };
        } else {
          let anyInstance = boot.data.instances[0];

          if (anyInstance) {
            return {
              instance: anyInstance,
              organization: anyInstance.organization,
              project: anyInstance.project
            };
          } else {
            return null;
          }
        }
      })
      .then(async res => {
        if (!res) {
          // Signing in adds everyone to the organization, which starts with a
          // project; without one, admins can create it from the projects page.
          let org = boot.data?.organizations[0];
          if (org) return Paths.organization.projects(org);

          setNoAccess(true);
          return null;
        }

        let { instance, organization, project } = res;

        if (intent === 'organization_settings')
          return Paths.organization.settings(organization);

        let homeBasePath = Paths.instance.home(organization, project, instance);
        if (!path) return homeBasePath;

        return joinPaths(homeBasePath, path);
      })
      .then(async path => {
        if (!path || navigatedRef.current) return;
        navigatedRef.current = true;

        navigate(path, { replace: true });
      });
  }, [boot.data, path, intent, organizationId]);

  if (noAccess) {
    return (
      <SetupLayout
        main={{
          title: 'No access yet',
          description: "You aren't a member of the organization. Ask an admin to invite you."
        }}
        backgroundUrl={bg}
      >
        <Button fullWidth onClick={() => location.assign(getConfig().auth.logoutPath)}>
          Sign out
        </Button>
      </SetupLayout>
    );
  }

  return null;
};
